<template>
    <div class="videoconference-link-switch">
        <div class="videoconference-link-switch__logo">
            <img :src="logoSrc" :alt="logoAlt" />
        </div>
        <CompassSwitch
            :modelValue="modelValue"
            :label="switchLabel"
            :caption="switchCaption"
            :disabled="disabled"
            @update:modelValue="emit('update:modelValue', $event)"
        />
    </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { Translator } from 'types/injects/translator.type';

type Provider = 'google' | 'outlook';

interface Props {
    modelValue: boolean;
    provider: Provider;
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false,
});

const emit = defineEmits<{
    'update:modelValue': [value: boolean];
}>();

const $t = inject('$t') as Translator;

const logoSrc = computed((): string => {
    return props.provider === 'google'
        ? '/ressources/logged/img/illustrations/common/logo/google-meet.svg'
        : '/ressources/logged/img/illustrations/common/logo/microsoft-teams.svg';
});

const logoAlt = computed((): string => {
    return props.provider === 'google' ? 'Google Meet' : 'Microsoft Teams';
});

const switchLabel = computed((): string => {
    return props.provider === 'google'
        ? $t.__('activities.activitiesFormPanel.add_google_meet_link')
        : $t.__('activities.activitiesFormPanel.add_teams_link');
});

const switchCaption = computed((): string => {
    return props.provider === 'google'
        ? $t.__('activities.activitiesFormPanel.google_meet_caption')
        : $t.__('activities.activitiesFormPanel.teams_caption');
});
</script>

<style lang="scss" scoped>
.videoconference-link-switch {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);
    border: 1px solid var(--colors-common-border-default);
    border-radius: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-2);

    &__logo {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        padding: var(--spacing-0);
        background-color: var(--colors-common-background-subtle);
        border-radius: var(--spacing-1);

        img {
            width: 24px;
            height: 24px;
        }
    }
}
</style>
